import Vue from 'vue';

function getCircularReplacer() {
  const seen = new WeakSet();
  return (key, value) => {
    if (value instanceof Vue) {
      return {
        component: value.$name,
      };
    }

    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
}

const ErrorTrackingPlugin = {
  install(Vue, options) {
    if (this.installed)
      return;

    const { handler } = options;

    Vue.config.errorHandler = function (err, vm, info) {
      console.error(err, info);

      handler({
        type: 'vue',
        ver: __BUILD_UTC_AT__,
        error: {
          vmname: vm?.$options.name,
          msg: err.message,
          location: window?.location.href,
          exc: JSON.stringify(err, getCircularReplacer()),
          info,
          currentRoute: {
            fullPath: vm?.$route?.fullPath,
            params: vm?.$route?.params,
            query: vm?.$route?.query,
          },
        },
      });
    };

    window?.addEventListener?.('error', ({ message, filename, lineno, colno, error }) => {
      if (message === 'Script error.') {
        // пропускаем не наши скрипты (crossorigin в действии)
        return;
      }

      handler({
        type: 'window',
        ver: __BUILD_UTC_AT__,
        error: {
          msg: message,
          exc: JSON.stringify(error, getCircularReplacer()),
          location: window?.location.href,
          script: filename,
          line: lineno,
          column: colno,
        },
        location: window.location.href,
      });
    });

    this.installed = true;
  },
};

export default ErrorTrackingPlugin;
